import { Inject, Injectable } from "@angular/core";
import { BaseLayerItemService } from "./base-layer-item.service";
import { BaseLayerProviderService } from "./base-layer-provider.service";

@Injectable({
  providedIn: 'root',
})
export class LayerItemManagerService {
  constructor(
    @Inject(BaseLayerItemService) private _layerItemServices: BaseLayerItemService[],
    @Inject(BaseLayerProviderService) private _layerProviderServices: BaseLayerProviderService[]
  ) {}

  getLayerItemService(type: string): BaseLayerItemService {
    return this._layerItemServices.find((service) => service.type === type);
  }

  getLayerProviderService(type: string): BaseLayerProviderService {
    return this._layerProviderServices.find((service) => service.type === type);
  }
}
